/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2022
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React from 'react';
import Bootstrap from './Bootstrap';
import registerServiceWorker from './registerServiceWorker';
import { createRoot } from 'react-dom/client';

function getDomNode(selector) {
  // If not a string, assume we were passed a DOM Node already
  if (typeof selector !== 'string') {
    return selector;
  }

  return document.querySelector(selector);
}

let domNode;
if (window.apiConnectExplorer && window.apiConnectExplorer.attachPoint) {
  domNode = getDomNode(window.apiConnectExplorer.attachPoint);
} else {
  domNode = getDomNode('apiconnect-explorer');
}
const root = createRoot(domNode);

root.render(<Bootstrap />);
registerServiceWorker();
